import { render } from "./VehicleRequestView.vue?vue&type=template&id=0c25cb6a&scoped=true"
import script from "./VehicleRequestView.vue?vue&type=script&lang=js"
export * from "./VehicleRequestView.vue?vue&type=script&lang=js"

import "./VehicleRequestView.vue?vue&type=style&index=0&id=0c25cb6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c25cb6a"]])

export default __exports__